import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center px-5 tactical-grid-bg">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md border border-white/10 bg-surface p-8 md:p-10"
      >
        <div className="flex flex-col items-center text-center mb-8">
          <Logo size={80} />
          <div className="mt-6 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.3em] text-acid">
            <Lock size={14} /> Admin Access
          </div>
          <h1 className="font-display uppercase text-3xl text-white mt-2">Dashboard Login</h1>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <span className="font-mono text-[10px] uppercase tracking-widest text-silver mb-2 block">Email</span>
            <input value={email} onChange={(e) => setEmail(e.target.value)} className={cls} data-testid="login-email" placeholder="admin@zuritas.com" />
          </div>
          <div>
            <span className="font-mono text-[10px] uppercase tracking-widest text-silver mb-2 block">Password</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={cls} data-testid="login-password" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-acid py-4 font-heading font-semibold uppercase tracking-wide text-obsidian hover:bg-acid-hover transition-colors disabled:opacity-60" data-testid="login-submit">
            {loading ? "..." : "Enter"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}

const cls = "w-full bg-obsidian border border-white/15 px-4 py-3 text-white placeholder:text-white/25 outline-none focus:border-acid transition-colors text-sm";
